import React from "react"

import * as st from './Image.styled.js'

const Image = ({
  className,
  id,
  name,
  color,
}) => (
  <st.ImageBg
    className={className}
    color={color}
  >
    {id === "custom-fields" && (
      <st.ImageCustomFields
        src="//cdn-platform.scope-dev.ws/website/images/screens/index/features/fields.webp"
        srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/features/fields.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/features/fields@2x.webp 2x"
        width={600}
        height={510}
        alt={name}
      />
    )}
    {id === "dynamic-texts" && (
      <st.ImageDynamicTexts
        src="//cdn-platform.scope-dev.ws/website/images/screens/index/features/dynamic-text.webp"
        srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/features/dynamic-text.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/features/dynamic-text@2x.webp 2x"
        width={560}
        height={460}
        alt={name}
      />
    )}
    {id === "sharing-quick-actions" && (
      <st.ImageSharingQuickActions
        src="//cdn-platform.scope-dev.ws/website/images/screens/index/features/share.webp"
        srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/features/share.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/features/share@2x.webp 2x"
        width={576}
        height={277}
        alt={name}
      />
    )}
    {id === "magic-links" && (
      <st.ImageMagicLinks
        src="//cdn-platform.scope-dev.ws/website/images/screens/index/features/email-invite.webp"
        srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/features/email-invite.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/features/email-invite@2x.webp 2x"
        width={628}
        height={510}
        alt={name}
      />
    )}
    {id === "form-templates" && (
      <st.ImageFormTemplates
        src="//cdn-platform.scope-dev.ws/website/images/screens/index/features/form-templates.webp"
        srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/features/form-templates.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/features/form-templates@2x.webp 2x"
        width={620}
        height={440}
        alt={name}
      />
    )}
    {id === "documents" && (
      <st.ImageDocuments
        src="//cdn-platform.scope-dev.ws/website/images/screens/index/features/documents.webp"
        srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/features/documents.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/features/documents@2x.webp 2x"
        width={640}
        height={496}
        alt={name}
      />
    )}
    {id === "task-dependencies" && (
      <st.ImageTaskDependencies
        src="//cdn-platform.scope-dev.ws/website/images/screens/index/features/dependencies.webp"
        srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/features/dependencies.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/features/dependencies@2x.webp 2x"
        width={570}
        height={490}
        alt={name}
      />
    )}
    {id === "checklists" && (
      <st.ImageChecklists
        src="//cdn-platform.scope-dev.ws/website/images/screens/index/features/checklist.png"
        srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/features/checklist.png 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/features/checklist@2x.png 2x"
        width={560}
        height={351}
        alt={name}
      />
    )}
    {id === "advanced-filters" && (
      <st.ImageAdvancedFilters
        src="//cdn-platform.scope-dev.ws/website/images/screens/index/features/filters.webp"
        srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/features/filters.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/features/filters@2x.webp 2x"
        width={800}
        height={540}
        alt={name}
      />
    )}
    {id === "advanced-grouping" && (
      <st.ImageAdvancedGrouping
        src="//cdn-platform.scope-dev.ws/website/images/screens/index/features/grouping.webp"
        srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/features/grouping.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/features/grouping@2x.webp 2x"
        width={800}
        height={540}
        alt={name}
      />
    )}
    {id === "slack-canvases" && (
      <st.ImageSlackCanvases
        src="//cdn-platform.scope-dev.ws/website/images/screens/index/features/slack-canvas.webp"
        srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/features/slack-canvas.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/features/slack-canvas@2x.webp 2x"
        width={660}
        height={490}
        alt={name}
      />
    )}
    {id === "internal-tasks" && (
      <st.ImageInternalTasks
        src="//cdn-platform.scope-dev.ws/website/images/screens/index/features/internal-task.webp"
        srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/features/internal-task.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/features/internal-task@2x.webp 2x"
        width={480}
        height={380}
        alt={name}
      />
    )}
    {id === "internal-communication" && (
      <st.ImageInternalCommunication
        src="//cdn-platform.scope-dev.ws/website/images/screens/index/features/internal-message.webp"
        srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/features/internal-message.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/features/internal-message@2x.webp 2x"
        width={640}
        height={430}
        alt={name}
      />
    )}
    {id === "weekly-updates" && (
      <st.ImageWeeklyUpdates
        src="//cdn-platform.scope-dev.ws/website/images/screens/index/features/email-summary.webp"
        srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/features/email-summary.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/features/email-summary@2x.webp 2x"
        width={628}
        height={510}
        alt={name}
      />
    )}
    {id === "personal-views" && (
      <st.ImagePersonalViews
        src="//cdn-platform.scope-dev.ws/website/images/screens/index/features/private-view.webp"
        srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/features/private-view.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/features/private-view@2x.webp 2x"
        width={800}
        height={540}
        alt={name}
      />
    )}
    {id === "accounts-management" && (
      <st.ImageAccountsManagement
        src="//cdn-platform.scope-dev.ws/website/images/screens/index/features/accounts.webp"
        srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/features/accounts.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/features/accounts@2x.webp 2x"
        width={620}
        height={440}
        alt={name}
      />
    )}
    {id === "time-tracking" && (
      <st.ImageTimeTracking
        src="//cdn-platform.scope-dev.ws/website/images/screens/index/features/task-tracking.webp"
        srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/features/task-tracking.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/features/task-tracking@2x.webp 2x"
        width={743}
        height={526}
        alt={name}
      />
    )}
    {id === "highlighting-fields" && (
      <st.ImageHighlightingFields
        src="//cdn-platform.scope-dev.ws/website/images/screens/index/features/highlighted-field.webp"
        srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/features/highlighted-field.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/features/highlighted-field@2x.webp 2x"
        width={800}
        height={540}
        alt={name}
      />
    )}
    {id === "branded-portal" && (
      <st.ImageBrandedPortal
        src="//cdn-platform.scope-dev.ws/website/images/screens/index/features/portal.webp"
        srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/features/portal.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/features/portal@2x.webp 2x"
        width={640}
        height={485}
        alt={name}
      />
    )}
    {id === "dark-mode" && (
      <st.ImageDarkMode
        src="//cdn-platform.scope-dev.ws/website/images/screens/index/features/darkmode.webp"
        srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/features/darkmode.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/features/darkmode@2x.webp 2x"
        width={622}
        height={412}
        alt={name}
      />
    )}
    {id === "api" && (
      <st.ImageApi
        src="//cdn-platform.scope-dev.ws/website/images/screens/index/features/api.png"
        srcSet="//cdn-platform.scope-dev.ws/website/images/screens/index/features/api.png 1x, //cdn-platform.scope-dev.ws/website/images/screens/index/features/api@2x.png 2x"
        width={500}
        height={460}
        alt={name}
      />
    )}
  </st.ImageBg>
)

export default Image
